import { PersistedWidgetSpec } from 'shared/types/widgets'

import { isAiArtifactTile } from '../../utils/aiTilesPersistence'

export const getPinnedPublicIds = (
  items: PersistedWidgetSpec[]
): Set<string> => {
  const ids = new Set<string>()
  for (const item of items) {
    if (isAiArtifactTile(item)) ids.add(item.config.publicId)
  }
  return ids
}
